import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileDropdown from './ProfileDropDown';
import './Navbar.css';

function Navbar({ showBackButton = false }) {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="navbar-brand" onClick={() => navigate('/')}>
          <div className="brand-logo">
            <img
              src="/PMLogo.png"
              alt="Playmaker Media Kit"
              className="logo-image"
            />
          </div>
          <div className="brand-logo-words">
            <img
              src="/PMlogowords.png"
              alt="Playmaker Media Kit"
              className="logo-image"
            />
          </div>
        </div>
      </div>
      <div className="navbar-right">
        <ProfileDropdown />
      </div>
    </nav>
  );
}

export default Navbar;
